import axios from 'axios'

export default class Etiquetas {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/etiquetas/`
    this.urlImg = `${url}/api/arquivos/etiquetas/`
    this.tokenBearer = tokenBearer
  }

  getLayout () {
    return new Promise(async (resolve, reject) => {
      let optionsLayout = {
        method: 'get',
        url: this.url + 'layoutEtiquetas',
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseLayout = await axios(optionsLayout)
        resolve(responseLayout)
      } catch (err) {
        reject(err)
      }
    })
  }

  getTipos () {
    return new Promise(async (resolve, reject) => {
      let optionsTipos = {
        method: 'get',
        url: this.url + 'tipoEtiquetas',
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseTipos = await axios(optionsTipos)
        resolve(responseTipos)
      } catch (err) {
        reject(err)
      }
    })
  }

  exportar (data, args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: this.url + 'gerarEtiquetas?' + args,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob',
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getImg (valor) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlImg + valor,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getOrdenacoes (tipoEtiqueta) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.url + 'ordenacaoEtiquetas?tipoEtiqueta=' + tipoEtiqueta,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
